'use client';

import SearchForm from '@components/Search/SearchForm';
import { useSiteConfig } from '@commons/SiteConfig';

export default function SiteHeaderSearchForm({ siteHeaderOverlayId = '' }) {
  const { siteMeta, dictionary } = useSiteConfig();
  const searchPageUrl = siteMeta?.settings?.search_page?.url || '/sok';

  // Close the SiteHeader dialog once the search navigates away
  const handleSearch = () => {
    if (!siteHeaderOverlayId) {
      return;
    }
    const dialog = document.querySelector(`#${siteHeaderOverlayId}`);
    if (dialog instanceof HTMLDialogElement && dialog.open) {
      dialog.close();
    }
  };

  return <></>;

  return (
    <div className="SiteHeader__search Search">
      <SearchForm searchDictionary={dictionary?.search || {}} searchPageUrl={searchPageUrl} didSearch={handleSearch} />
    </div>
  );
}
